package org.teddapp.project.ui.finance

import org.teddapp.project.ui.today.currentMonthName

import org.teddapp.project.ui.teddClickable

import org.teddapp.project.ui.teddCardShadow

import org.teddapp.project.ui.TeddType

import org.teddapp.project.ui.TeddTagTone

import org.teddapp.project.ui.TeddTag

import org.teddapp.project.ui.TeddTabs

import org.teddapp.project.ui.TeddTab

import org.teddapp.project.ui.TeddSize

import org.teddapp.project.ui.TeddIconButton

import org.teddapp.project.ui.TeddFineProgress

import org.teddapp.project.ui.TeddAmountSize

import org.teddapp.project.ui.TeddAmount

import androidx.compose.ui.text.style.TextOverflow

import org.teddapp.project.ui.TeddSpace

import androidx.compose.foundation.layout.requiredWidthIn

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.tedd.db.Expense_list
import com.tedd.db.Expense_list_item
import com.tedd.db.Finance_account
import com.tedd.db.Finance_category
import com.tedd.db.Finance_transaction
import kotlinx.coroutines.launch
import org.teddapp.project.db.ParentKind
import org.teddapp.project.db.TeddRepositories
import org.teddapp.project.ui.LocalUseFullScreenForm
import org.teddapp.project.ui.TeddButton
import org.teddapp.project.ui.TeddButtonKind
import org.teddapp.project.ui.TeddButtonSize
import org.teddapp.project.ui.TeddIcon
import org.teddapp.project.ui.TeddLogo
import org.teddapp.project.ui.TeddSnackbarHost
import org.teddapp.project.ui.TeddTokens
import org.teddapp.project.ui.nav.Section
import org.teddapp.project.ui.rememberTeddSnackbarState

// ──────────────────────────────────────────────────────────────────────
// Parties propres à la mise en page étendue : barre latérale des comptes,
// bandeau du compte, barre d'onglets.
// ──────────────────────────────────────────────────────────────────────

/** Les comptes : 288 dp par défaut, de 240 à 440. */
private val FINANCE_PANE = org.teddapp.project.ui.PaneSpec("finance.accounts", default = 288.dp, min = 240.dp, max = 440.dp)

@Composable
internal fun FinanceSidebar(
    accounts: List<Finance_account>,
    selectedId: String?,
    onSelect: (String) -> Unit,
    monthTxns: List<Finance_transaction>,
    categories: List<Finance_category>,
    hideBalance: Boolean,
    onToggleHide: () -> Unit,
    onCreateAccount: () -> Unit,
    defaultAccountId: String? = null,
    onToggleDefault: (String) -> Unit = {},
) {
    // Colonne posée sur le papier, séparée du contenu par un filet : la barre latérale
    // de l'application est déjà la zone en retrait de l'écran.
    // Le filet du bord est la poignée : on y règle la largeur de la colonne.
    org.teddapp.project.ui.TeddSidePane(
        spec = FINANCE_PANE,
        collapsedContent = { expand ->
            org.teddapp.project.ui.TeddPaneRail(
                expand = expand,
                title = "les comptes",
                items = accounts.map { a -> org.teddapp.project.ui.PaneRailItem(a.id, a.name, a.icon, a.id == selectedId) { onSelect(a.id) } },
            )
        },
    ) {
    Row(Modifier.fillMaxSize()) {
        Column(
            modifier = Modifier.weight(1f).fillMaxHeight(),
            verticalArrangement = Arrangement.spacedBy(TeddSpace.S4),
        ) {
            FinanceTotalCard(accounts = accounts, hideBalance = hideBalance)
            Column(verticalArrangement = Arrangement.spacedBy(TeddSpace.S2)) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Text("COMPTES", Modifier.weight(1f).padding(start = TeddSpace.S1), color = TeddTokens.InkMuted, style = TeddType.Overline)
                    TeddIconButton(onClick = onCreateAccount, size = 28.dp) {
                        TeddIcon(name = "plus", size = 16.dp, color = TeddTokens.InkMuted)
                    }
                }
                accounts.forEach { a ->
                    AccountRow(
                        account = a,
                        active = a.id == selectedId,
                        isDefault = a.id == defaultAccountId,
                        onToggleDefault = { onToggleDefault(a.id) },
                        onClick = { onSelect(a.id) },
                    )
                }
            }
            Column(verticalArrangement = Arrangement.spacedBy(TeddSpace.S2)) {
                Text(
                    "DÉPENSES DU MOIS, PAR CATÉGORIE",
                    Modifier.padding(start = TeddSpace.S1),
                    color = TeddTokens.InkMuted,
                    style = TeddType.Overline,
                )
                CategoryBreakdown(txns = monthTxns, categories = categories)
            }
            Spacer(modifier = Modifier.weight(1f))
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2)) {
                Column(Modifier.weight(1f)) {
                    Text("Total en FCFA", color = TeddTokens.InkMuted, style = TeddType.Caption)
                    val totalXof = accounts.filter { it.currency == "XOF" && it.is_deleted == 0L }.sumOf { it.balance }
                    if (hideBalance) Text("• • • • •", color = TeddTokens.Ink, style = TeddType.Amount)
                    else TeddAmount(totalXof)
                }
                TeddIconButton(onClick = onToggleHide, active = hideBalance) {
                    TeddIcon(name = if (hideBalance) "eye-off" else "eye", size = 16.dp, color = TeddTokens.InkMuted)
                }
            }
        }
    }
    }
}

/** Libellé d'une devise tel qu'on l'écrit après un montant. */
internal fun currencyLabel(currency: String): String = if (currency == "XOF") "FCFA" else currency

/**
 * Un compte dans la liste. Le compte choisi se pose sur la surface ; sa couleur
 * (choisie par l'utilisateur) n'apparaît qu'en pastille, jamais en fond.
 */
@Composable
internal fun AccountRow(
    account: Finance_account,
    active: Boolean,
    onClick: () -> Unit,
    isDefault: Boolean = false,
    onToggleDefault: (() -> Unit)? = null,
) {
    val shape = RoundedCornerShape(TeddTokens.RMd)
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .then(if (active) Modifier.teddCardShadow(shape) else Modifier)
            .teddClickable(
                onClick = onClick,
                shape = shape,
                fill = if (active) TeddTokens.Surface else Color.Transparent,
                hover = if (active) TeddTokens.Surface else TeddTokens.SurfaceSunken,
                role = null,
            )
            .then(if (active) Modifier.border(1.dp, TeddTokens.Line, shape) else Modifier)
            .padding(horizontal = TeddSpace.S3, vertical = 10.dp),
    ) {
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(TeddSpace.S3)) {
            Box(
                Modifier.size(36.dp).background(TeddTokens.SurfaceSunken, RoundedCornerShape(TeddTokens.RSm)),
                contentAlignment = Alignment.Center,
            ) {
                TeddIcon(name = account.icon, size = 18.dp, color = TeddTokens.InkMuted)
            }
            Column(modifier = Modifier.weight(1f)) {
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                    Box(Modifier.size(7.dp).background(parseFinHex(account.color), CircleShape))
                    Text(
                        text = account.name,
                        color = TeddTokens.Ink,
                        style = TeddType.Label,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                    )
                }
                val sub = if (account.bank != null) {
                    val last = account.last4?.let { " · ····$it" } ?: ""
                    "${account.bank}$last"
                } else "Mobile money"
                Text(text = sub, color = TeddTokens.InkMuted, style = TeddType.Caption, maxLines = 1)
            }
            Text(
                text = money(account.balance, account.currency, compact = true),
                color = TeddTokens.Ink,
                style = TeddType.Mono.copy(fontWeight = FontWeight(500)),
                maxLines = 1,
            )
        }
        if (onToggleDefault != null && active) {
            Row(
                Modifier.padding(start = 48.dp, top = 6.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2),
            ) {
                if (isDefault) TeddTag("Compte par défaut", tone = TeddTagTone.Brand)
                Text(
                    text = if (isDefault) "Retirer" else "Définir par défaut",
                    color = TeddTokens.InkMuted,
                    style = TeddType.Caption,
                    modifier = Modifier.teddClickable(onClick = onToggleDefault).padding(horizontal = 4.dp, vertical = 2.dp),
                )
            }
        }
    }
}

@Composable
internal fun CategoryBreakdown(txns: List<Finance_transaction>, categories: List<Finance_category>) {
    val totals = remember(txns) {
        val m = mutableMapOf<String, Long>()
        for (t in txns) {
            val k = t.cat_id ?: continue
            m[k] = (m[k] ?: 0L) + t.amount
        }
        m
    }
    val sum = totals.values.sum().coerceAtLeast(1L)
    val top = totals.entries.sortedByDescending { it.value }.take(5)
    Column(
        modifier = Modifier.fillMaxWidth().padding(horizontal = TeddSpace.S1),
        verticalArrangement = Arrangement.spacedBy(TeddSpace.S3),
    ) {
        if (top.isEmpty()) {
            Text("Aucune dépense ce mois.", color = TeddTokens.InkMuted, style = TeddType.Caption)
            return@Column
        }
        top.forEach { (catId, amt) ->
            val cat = categories.firstOrNull { it.id == catId } ?: return@forEach
            val share = (amt.toDouble() / sum.toDouble()).toFloat()
            Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                    Box(Modifier.size(7.dp).background(parseFinHex(cat.color), CircleShape))
                    Text(
                        cat.name,
                        Modifier.weight(1f),
                        color = TeddTokens.Ink,
                        style = TeddType.Label.copy(fontWeight = FontWeight(400)),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                    )
                    Text("${(share * 100).toInt()} %", color = TeddTokens.InkMuted, style = TeddType.MonoSm)
                    Text(money(amt, "XOF", compact = true), color = TeddTokens.Ink, style = TeddType.MonoSm)
                }
                TeddFineProgress(fraction = share, height = 4.dp)
            }
        }
    }
}

// ─────────────────────────────────────────────────────────────────────
// Hero + tab bar
// ─────────────────────────────────────────────────────────────────────
@Composable
internal fun FinanceHero(
    account: Finance_account?,
    txns: List<Finance_transaction>,
    onEditAccount: () -> Unit,
) {
    val currency = account?.currency ?: "XOF"
    val monthTxns = txns.filter { it.date in MONTH_START..MONTH_END && it.is_deleted == 0L }
    val monthIn = monthTxns.filter { it.type == "income" && it.account_id == account?.id }.sumOf { it.amount }
    val monthOut = monthTxns.filter { it.type == "expense" && it.account_id == account?.id }.sumOf { it.amount }
    val month = currentMonthName()
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(start = TeddSpace.S8, end = TeddSpace.S8, top = TeddSpace.S8, bottom = TeddSpace.S5),
        verticalAlignment = Alignment.Bottom,
        horizontalArrangement = Arrangement.spacedBy(TeddSpace.S6),
    ) {
        Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(TeddSpace.S1)) {
            Text(
                text = listOfNotNull(account?.bank ?: "Mobile money", account?.last4?.let { "····$it" })
                    .joinToString(" · ").uppercase(),
                color = TeddTokens.InkMuted,
                style = TeddType.MonoSm,
            )
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(TeddSpace.S2)) {
                Text(
                    text = account?.name ?: "Aucun compte",
                    color = TeddTokens.Ink,
                    style = TeddType.Title1,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
                if (account != null) {
                    TeddIconButton(onClick = onEditAccount) {
                        TeddIcon(name = "edit", size = 16.dp, color = TeddTokens.InkMuted)
                    }
                }
            }
            Spacer(Modifier.height(TeddSpace.S1))
            TeddAmount(account?.balance ?: 0L, currency = currencyLabel(currency), size = TeddAmountSize.Lg)
            if (account != null) {
                Spacer(Modifier.height(TeddSpace.S1))
                AccountThresholdBadges(account = account, onLight = true)
            }
        }
        FinStat("Entrées · $month", monthIn, currency, signed = true)
        FinStat("Sorties · $month", -monthOut, currency)
        FinStat("Net · $month", monthIn - monthOut, currency, signed = true)
        Column(horizontalAlignment = Alignment.End, verticalArrangement = Arrangement.spacedBy(TeddSpace.S1)) {
            Text("14 derniers jours", color = TeddTokens.InkMuted, style = TeddType.Caption)
            AccountSparkline(accountTxns = txns, currentAccountId = account?.id)
        }
    }
}

/** Un chiffre du mois dans le bandeau : libellé, puis montant en chiffres tabulaires. */
@Composable
private fun FinStat(label: String, value: Long, currency: String, signed: Boolean = false) {
    Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
        Text(label, color = TeddTokens.InkMuted, style = TeddType.Caption, maxLines = 1)
        TeddAmount(value, currency = currencyLabel(currency), signed = signed)
    }
}

@Composable
internal fun FinStatBlock(label: String, value: String, color: Color, highlight: Boolean = false) {
    val mod = if (highlight) {
        Modifier
            .clip(RoundedCornerShape(TeddTokens.RSm))
            .background(TeddTokens.Surface, RoundedCornerShape(TeddTokens.RSm))
            .border(1.dp, TeddTokens.Line, RoundedCornerShape(TeddTokens.RSm))
            .padding(horizontal = 12.dp, vertical = 8.dp)
    } else Modifier.padding(horizontal = 12.dp, vertical = 8.dp)
    Column(modifier = mod) {
        Text(
            text = label.uppercase(),
            color = TeddTokens.InkMuted,
            fontSize = 10.sp,
            fontWeight = FontWeight.SemiBold,
            letterSpacing = 0.4.sp,
        )
        Spacer(modifier = Modifier.height(2.dp))
        Text(
            text = value,
            color = color,
            fontSize = 15.sp,
            fontWeight = FontWeight.SemiBold,
        )
    }
}

@Composable
internal fun FinanceTabBar(
    tab: FinanceTab,
    onTabChange: (FinanceTab) -> Unit,
    txnCount: Int,
    listsCount: Int,
    assetsCount: Int = 0,
    simulationsCount: Int = 0,
    onAddClick: () -> Unit,
) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(horizontal = TeddSpace.S8),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(TeddSpace.S3),
    ) {
        TeddTabs(
            tabs = FinanceTab.entries.map { t ->
                TeddTab(
                    id = t.key,
                    label = t.label,
                    count = when (t) {
                        FinanceTab.Transactions -> txnCount
                        FinanceTab.Dashboard -> null
                        FinanceTab.Lists -> listsCount
                        FinanceTab.Patrimoine -> assetsCount
                        FinanceTab.Simulation -> simulationsCount
                    },
                )
            },
            selected = tab.key,
            onSelect = { key -> FinanceTab.entries.firstOrNull { it.key == key }?.let(onTabChange) },
        )
        Spacer(modifier = Modifier.weight(1f))
        if (tab == FinanceTab.Transactions) {
            TeddButton(text = "Ajouter", kind = TeddButtonKind.Primary, onClick = onAddClick, icon = "plus", kbd = "N")
        }
    }
}

@Composable
internal fun TabButton(tab: FinanceTab, current: FinanceTab, count: Int, onClick: () -> Unit) {
    val on = tab == current
    Row(
        modifier = Modifier
            .height(40.dp)
            .clickable(
                interactionSource = remember { MutableInteractionSource() },
                indication = null,
                onClick = onClick,
            )
            .padding(horizontal = 16.dp, vertical = 8.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(6.dp),
    ) {
        TeddIcon(
            name = tab.icon,
            size = 13.dp,
            color = if (on) TeddTokens.Ink else TeddTokens.InkMuted,
            strokeWidth = if (on) 2.dp else 1.6.dp,
        )
        Text(
            text = tab.label,
            color = if (on) TeddTokens.Ink else TeddTokens.InkMuted,
            fontSize = 13.sp,
            fontWeight = if (on) FontWeight.SemiBold else FontWeight.Medium,
        )
        Box(
            modifier = Modifier
                .clip(RoundedCornerShape(TeddTokens.RFull))
                .background(TeddTokens.SurfaceSunken, RoundedCornerShape(TeddTokens.RFull))
                .border(1.dp, TeddTokens.Line, RoundedCornerShape(TeddTokens.RFull))
                .padding(horizontal = 6.dp, vertical = 1.dp),
        ) {
            Text(text = "$count", color = TeddTokens.InkMuted, fontSize = 10.5.sp)
        }
        if (on) {
            // Highlight underline (we draw a small accent block at the bottom)
        }
    }
    if (on) {
        // Underline drawn implicitly through the tab bar's bottom area
    }
}

// ─────────────────────────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────────────────────────
